import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { styles } from '../../../utils'

export default class NavbarLinks extends Component {
  state = {
    links: [
      {
        id: 0,
        path: '/',
        name: 'home'
      },
      {
        id: 1,
        path: '/services',
        name: 'services'
      },
      {
        id: 2,
        path: '/about',
        name: 'about'
      },
      {
        id: 3,
        path: '/contact',
        name: 'contact'
      }
    ]
  }
  render() {
    return (
      <LinkWrapper open={this.props.navbarOpen}>
        {this.state.links.map(item => {
          return (
            <li key={item.id}>
              <Link to={item.path} className='nav-link'>
                {item.name}
              </Link>
            </li>
          )
        })}
      </LinkWrapper>
    )
  }
}

const LinkWrapper = styled.ul`
  margin-bottom: 0;
  li {
    list-style-type: none;
  }
  background-color: #15396c;
  .nav-link {
    display: block;
    text-decoration: none;
    padding: 0.5rem 1rem 0.5rem 1rem;
    color: ${styles.colors.White};
    font-size: 20px;
    font-weight: 500;
    text-transform: capitalize;
    cursor: pointer;
    ${styles.transDefault};
    &:hover {
      background: ${styles.colors.Navy};
      color: ${styles.colors.softBlue};
      padding: 0.5rem 1rem 0.5rem 1.3rem;
    }
  }

  height: ${props => (props.open ? '240px' : '0px')};
  overflow: hidden;
  ${styles.transObject({})};

  @media (min-width: 768px) {
    height: auto;
    display: flex;
    margin: 0 auto;
    font-size: 1.1rem;
    .nav-link:hover {
      background-color: ${styles.colors.Navy};
      padding: 0.5rem 1rem 0.5rem 1rem;
    }
  }
`
